/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ConferenceBackend) {
      root.ConferenceBackend = {};
    }
    root.ConferenceBackend.PresentationsurveyquestionOptions = factory(root.ConferenceBackend.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PresentationsurveyquestionOptions model module.
   * @module model/PresentationsurveyquestionOptions
   * @version 0.0.1
   */

  /**
   * Constructs a new <code>PresentationsurveyquestionOptions</code>.
   * @alias module:model/PresentationsurveyquestionOptions
   * @class
   */
  var exports = function() {
    var _this = this;


  };

  /**
   * Constructs a <code>PresentationsurveyquestionOptions</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PresentationsurveyquestionOptions} obj Optional instance to populate.
   * @return {module:model/PresentationsurveyquestionOptions} The populated <code>PresentationsurveyquestionOptions</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;



  return exports;
}));






// WEBPACK FOOTER //
// ./generated/src/model/PresentationsurveyquestionOptions.js